import { getDefaultConfig } from '@rainbow-me/rainbowkit';
import { monad } from './chains';
import { http } from 'wagmi';

// WalletConnect Project ID - Get yours at https://cloud.walletconnect.com
const WALLETCONNECT_PROJECT_ID = import.meta.env.VITE_WALLETCONNECT_PROJECT_ID;
if (!WALLETCONNECT_PROJECT_ID) {
    console.warn('[wagmi] VITE_WALLETCONNECT_PROJECT_ID not set in .env');
}

export const config = getDefaultConfig({
    appName: 'DUCK on Monad',
    projectId: WALLETCONNECT_PROJECT_ID,
    chains: [monad],
    transports: {
        [monad.id]: http(),
    },
});

export { monad };
